import { OpenedEvent } from 'onesignal-cordova-plugin/dist/models/NotificationOpened';
import { default as OneSignalWeb } from 'react-onesignal';
import { OneSignalConfig, OneSignalSDK } from './OneSignalService';

/** OneSignal Web Push Bridge */
export class OneSignalWebImpl implements OneSignalSDK {
  private logger = console;
  setLogger(logger: Console) {
    this.logger = logger;
  }
  init(config: OneSignalConfig): Promise<void> {
    return OneSignalWeb.init(config);
  }
  isPushNotificationsEnabled(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      OneSignalWeb.isPushNotificationsEnabled((isEnabled) => {
        resolve(isEnabled);
      });
    });
  }
  setSubscription(newSubscription: boolean, externalUserId: string) {
    // Must set external id BEFORE subscribe or unsubscribe
    OneSignalWeb.setExternalUserId(externalUserId);
    return OneSignalWeb.setSubscription(newSubscription);
  }
  getNotificationPermission(onComplete?: Function) {
    return OneSignalWeb.getNotificationPermission().then((notificationPerm) => {
      return onComplete && onComplete(notificationPerm);
    });
  }
  showPrompt() {
    return OneSignalWeb.showNativePrompt();
  }
  setNotificationOpenedHandler(handler: (event: OpenedEvent) => void) {
    const openAction = (data) => {
      handler({
        action: {
          type: data.action ? 1 : 0,
        },
        notification: {
          body: data.content,
          title: data.heading,
          rawPayload: {},
          additionalData: data.data,
          notificationId: '',
          launchURL: data.url,
        },
      });
    };
    OneSignalWeb.addListenerForNotificationOpened(openAction);
  }
  setNotificationWillShowInForegroundHandler(handler: (event) => void) {
    // No web implementation
  }
}
